import { useEffect, useState } from "react";
import { apiFetch } from "api/Api";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Link } from "react-router-dom";
import "assets/theme/admin_list.css";
import { FaTags, FaPlus, FaEdit, FaTrash, FaCheck, FaTimes } from "react-icons/fa";

const CategoryList = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");
  const [editDepartmentId, setEditDepartmentId] = useState("");
  const [editPriority, setEditPriority] = useState("MEDIUM");

  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchDepartments();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await apiFetch("super_admin/list_category");
      setCategories(res.categories || res);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchDepartments = async () => {
    try {
      const res = await apiFetch("super_admin/list_department");
      setDepartments(res.departments || res);
    } catch (error) {
      alert(error.message);
    }
  };

  const startEdit = (cat) => {
    setEditId(cat.category_id);
    setEditName(cat.category_name);
    setEditDepartmentId(cat.department_id);
    setEditPriority(cat.default_priority);
  };

  const cancelEdit = () => {
    setEditId(null);
    setEditName("");
    setEditDepartmentId("");
    setEditPriority("MEDIUM");
  };

  const updateCategory = async (id) => {
    if (!editName || !editDepartmentId || !editPriority) {
      alert("All fields are required");
      return;
    }

    try {
      await apiFetch(`super_admin/edit_category/${id}`, {
        method: "PUT",
        body: JSON.stringify({
          category_name: editName,
          department_id: editDepartmentId,
          default_priority: editPriority,
        }),
      });

      alert("Category updated successfully");
      cancelEdit();
      fetchCategories();
    } catch (error) {
      alert(error.message);
    }
  };

  const deleteCategory = async (id) => {
    if (!window.confirm("Are you sure you want to delete this category?")) return;

    try {
      await apiFetch(`super_admin/delete_category/${id}`, { method: "DELETE" });
      alert("Category deleted successfully");
      fetchCategories();
    } catch (error) {
      alert(error.message);
    }
  };

  const priorityBadgeClass = (priority) => {
    if (priority === "HIGH") return "badge-status badge-status-danger";
    if (priority === "MEDIUM") return "badge-status badge-status-warning";
    return "badge-status badge-status-success";
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="admin-page-container">
        {/* Header */}
        <div className="admin-header-card d-flex align-items-center justify-content-between flex-wrap gap-3">
          <div className="d-flex align-items-center">
            <div className="admin-header-icon">
              <FaTags />
            </div>
            <div>
              <h4 className="admin-header-title">वर्गवारी / श्रेणी व्यवस्थापन (Category Management)</h4>
              <p className="admin-header-subtitle mb-0">
                तक्रार व सेवानिहाय श्रेणी आणि मूळ प्राधान्यक्रम व्यवस्थापित करा
              </p>
            </div>
          </div>
          <Link className="btn-admin-add" to="/categories">
            <FaPlus /> नवीन श्रेणी जोडा
          </Link>
        </div>

        {/* Table Card */}
        <div className="admin-table-card">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-warning" role="status" />
              <p className="mt-2 text-muted fw-semibold">श्रेणी लोड होत आहेत...</p>
            </div>
          ) : categories.length === 0 ? (
            <div className="text-center py-5 text-muted">
              कोणतीही श्रेणी आढळली नाही.
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-admin-custom">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>श्रेणी (Category)</th>
                    <th>संबंधित विभाग (Department)</th>
                    <th>प्राधान्य (Default Priority)</th>
                    <th className="text-end">कृती (Actions)</th>
                  </tr>
                </thead>

                <tbody>
                  {categories.map((cat, index) => (
                    <tr key={cat.category_id}>
                      <td className="fw-bold text-secondary">{index + 1}</td>

                      <td>
                        {editId === cat.category_id ? (
                          <input
                            className="form-control form-control-sm admin-select py-1 px-2"
                            value={editName}
                            onChange={(e) => setEditName(e.target.value)}
                          />
                        ) : (
                          <strong className="text-dark">{cat.category_name}</strong>
                        )}
                      </td>

                      <td>
                        {editId === cat.category_id ? (
                          <select
                            className="form-select form-select-sm admin-select py-1 px-2"
                            value={editDepartmentId}
                            onChange={(e) => setEditDepartmentId(e.target.value)}
                          >
                            <option value="">Select Department</option>
                            {departments.map((d) => (
                              <option key={d.department_id} value={d.department_id}>
                                {d.department_name}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <span className="badge bg-light text-dark border">
                            {cat.department_name}
                          </span>
                        )}
                      </td>

                      <td>
                        {editId === cat.category_id ? (
                          <select
                            className="form-select form-select-sm admin-select py-1 px-2"
                            value={editPriority}
                            onChange={(e) => setEditPriority(e.target.value)}
                          >
                            <option value="LOW">LOW</option>
                            <option value="MEDIUM">MEDIUM</option>
                            <option value="HIGH">HIGH</option>
                          </select>
                        ) : (
                          <span className={priorityBadgeClass(cat.default_priority)}>
                            {cat.default_priority}
                          </span>
                        )}
                      </td>

                      <td className="text-end">
                        {editId === cat.category_id ? (
                          <div className="admin-action-group justify-content-end">
                            <button
                              className="btn-action-icon btn-action-view"
                              onClick={() => updateCategory(cat.category_id)}
                              title="जतन करा"
                            >
                              <FaCheck />
                            </button>
                            <button
                              className="btn-action-icon btn-action-delete"
                              onClick={cancelEdit}
                              title="रद्द करा"
                            >
                              <FaTimes />
                            </button>
                          </div>
                        ) : (
                          <div className="admin-action-group justify-content-end">
                            <button
                              className="btn-action-icon btn-action-edit"
                              onClick={() => startEdit(cat)}
                              title="संपादित करा"
                            >
                              <FaEdit />
                            </button>
                            <button
                              className="btn-action-icon btn-action-delete"
                              onClick={() => deleteCategory(cat.category_id)}
                              title="हटवा"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default CategoryList;
